export function roundToDecimals(num: number, decimalScale: number): number {
  if (num) {
    return Number(num.toFixed(decimalScale));
  } else {
    return num;
  }
}

export function roundDec(num: number, decimalScale: number, HalfUp: boolean = true): number {
  if (num && decimalScale >= 0 && decimalScale <= 100) {
    const factor = Math.pow(10, decimalScale);
    const roundedNum = HalfUp
      ? Math.ceil(num * factor) / factor
      : Math.floor(num * factor) / factor;
    return Number(roundedNum.toFixed(decimalScale));
  } else {
    return num;
  }
}

export function floorPrecised(number: number, precision: number): number {
  var power = Math.pow(10, precision);

  return Math.floor(number * power) / power;
}
